// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/close_modal_White.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Modal > div.window {
  border: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

div.Modal > div.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(38, 40, 47, 0.75);
  z-index: 3000;
}
div.Modal > div.window {
  border: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  background-color: #FFF;
  position: fixed;
  max-height: calc(100% - 20px);
  right: auto;
  -webkit-box-shadow: 2px 2px 5px #5F6766;
          box-shadow: 2px 2px 5px #5F6766;
  overflow: auto;
  z-index: 3001;
}
div.Modal > div.window.fullscreen {
  width: 100% !important;
  left: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
}
div.Modal > div.window.fullscreen content {
  height: 100vh;
}
div.Modal > div.window.fullscreen footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #FFF;
}
div.Modal > div.window.extra-wide {
  width: 1167px;
  left: calc(50% - 583.5px);
}
div.Modal > div.window.wide {
  width: 900px;
  left: calc(50% - 450px);
}
div.Modal > div.window.medium {
  width: 650px;
  left: calc(50% - 325px);
}
div.Modal > div.window.small {
  width: 400px;
  left: calc(50% - 200px);
}
div.Modal > div.window a.Button.close {
  top: 10px;
  right: 10px;
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: 20px;
  height: 20px;
  width: 20px;
  border: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  color: #FFF;
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 13px;
  font-family: sans-serif;
  z-index: 1010;
  cursor: pointer;
}
div.Modal > div.window div.header {
  margin: 0;
  padding: 17px;
  background-color: #002E33;
  color: #FFF;
}
div.Modal > div.window div.header h1 {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.075em;
  line-height: 11px;
  text-align: center;
  text-transform: uppercase;
}
div.Modal > div.window div.content {
  left: 0;
  right: 0;
  padding: 24px 32px;
}
div.Modal > div.window div.content h1 {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.075em;
  color: #002E33;
  text-align: center;
  text-transform: uppercase;
}
div.Modal > div.window div.content p {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #697588;
  line-height: 18px;
  margin: 0px;
  padding-top: 14px;
}
div.Modal > div.window footer,
div.Modal > div.window div.footer {
  text-align: center;
  border-top: 1px solid #E8E9F0;
  padding: 24px 32px;
}
div.Modal > div.window footer .Button,
div.Modal > div.window div.footer .Button {
  line-height: 12px;
  padding: 11px 16px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
div.Modal > div.window footer .Button:not(:first-child),
div.Modal > div.window div.footer .Button:not(:first-child) {
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Modal/Modal.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,QAAA;EACA,mCAAA;UAAA,2BAAA;AADF;;AAmGE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wCAAA;EACA,aAAA;AAhGJ;AAmGE;EAvGA,SAAA;EACA,QAAA;EACA,mCAAA;UAAA,2BAAA;EA0HE,sBC9HI;ED+HJ,eAAA;EACA,6BAAA;EACA,WAAA;EACA,uCAAA;UAAA,+BAAA;EACA,cAAA;EACA,aAAA;AAlHJ;AA0FI;EACE,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AAxFN;AA0FM;EACE,aAAA;AAxFR;AA2FM;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBC1HA;ADiCR;AAqGI;EACE,aAAA;EACA,yBAAA;AAnGN;AAsGI;EACE,YAAA;EACA,uBAAA;AApGN;AAuGI;EACE,YAAA;EACA,uBAAA;AArGN;AAwGI;EACE,YAAA;EACA,uBAAA;AAtGN;AAyGI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,2EAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;UAAA,gBAAA;EACA,WCpKE;EDqKF,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AAvGN;AA0GI;EAtKF,SAAA;EACA,aAAA;EACA,yBChBa;EDiBb,WCXM;AD0ER;AA7DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AA+DJ;AA+FI;EAzJF,OAAA;EACA,QAAA;EACA,kBAAA;AA6DF;AA3DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cCxCW;EDyCX,kBAAA;EACA,yBAAA;AA6DJ;AA1DE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCEK;EDDL,iBAAA;EACA,WAAA;EACA,iBAAA;AA4DJ;AA4EI;;EAnIF,kBAAA;EACA,6BAAA;EACA,kBAAA;AA2DF;AAzDE;;EACE,iBAAA;EACA,kBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AA4DJ;AA1DI;;EACE,iBAAA;AA6DN","sourcesContent":["@import \"../../../Global/Colors.scss\";\n\ndiv.Modal>div.window {\n  border: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n\n@mixin modalWindowRules {\n  border: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n@mixin headerRules {\n  margin: 0;\n  padding: 17px;\n  background-color: $DeepSeaGreen;\n  color: $White;\n\n  h1 {\n    margin: 0;\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.075em;\n    line-height: 11px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n}\n\n@mixin contentRules {\n  left: 0;\n  right: 0;\n  padding: 24px 32px;\n\n  h1 {\n    margin: 0;\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.075em;\n    color: $DeepSeaGreen;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  p {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 500;\n    color: $Gray90;\n    line-height: 18px;\n    margin: 0px;\n    padding-top: 14px;\n  }\n}\n\n@mixin footerRules {\n  text-align: center;\n  border-top: 1px solid $Gray30;\n  padding: 24px 32px;\n\n  .Button {\n    line-height: 12px;\n    padding: 11px 16px;\n    width: fit-content;\n\n    &:not(:first-child) {\n      margin-left: 15px;\n    }\n  }\n}\n\n@mixin checkboxRules {\n  margin-top: 24px;\n  margin-bottom: 0px;\n\n  >div.check {\n    border-radius: 2px;\n    margin-top: 0px;\n    cursor: pointer;\n  }\n\n  >div.check.checked {\n    background: $ElectricGreen url(\"~images/checkmark_deepSeaGreen.svg\");\n    border: 1px solid $ElectricGreen;\n    background-size: 8px 6px;\n    background-repeat: no-repeat;\n    background-position: 2px 3px;\n  }\n\n  >span.Label {\n    display: inline;\n    position: inherit;\n    color: $DeepSeaGreen;\n    font-weight: 500;\n    font-size: 12px;\n  }\n}\n\ndiv.Modal {\n\n  >div.overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba($Gray200, 0.75);\n    z-index: 3000;\n  }\n\n  >div.window {\n    @include modalWindowRules;\n\n    &.fullscreen {\n      width: 100% !important;\n      left: 0 !important;\n      height: 100% !important;\n      max-height: 100% !important;\n\n      content {\n        height: calc(100vh);\n      }\n\n      footer {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n        background: $White;\n      }\n    }\n\n    background-color: $White;\n    position: fixed;\n    max-height: calc(100% - 20px);\n    right: auto;\n    box-shadow: 2px 2px 5px $shadowColor;\n    overflow: auto;\n    z-index: 3001;\n\n    &.extra-wide {\n      width: 1167px;\n      left: calc(50% - 583.5px);\n    }\n\n    &.wide {\n      width: 900px;\n      left: calc(50% - 450px);\n    }\n\n    &.medium {\n      width: 650px;\n      left: calc(50% - 325px);\n    }\n\n    &.small {\n      width: 400px;\n      left: calc(50% - 200px);\n    }\n\n    a.Button.close {\n      top: 10px;\n      right: 10px;\n      position: absolute;\n      background: url(\"~images/close_modal_White.svg\") center center no-repeat;\n      background-size: 20px;\n      height: 20px;\n      width: 20px;\n      border: none;\n      box-shadow: none;\n      color: $White;\n      padding: 0;\n      margin: 0;\n      font-weight: 700;\n      font-size: 13px;\n      font-family: sans-serif;\n      z-index: 1010;\n      cursor: pointer;\n    }\n\n    div.header {\n      @include headerRules;\n    }\n\n    div.content {\n      @include contentRules;\n    }\n\n    footer,\n    div.footer {\n      @include footerRules;\n    }\n  }\n\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
